export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const PASSWORD_CHANGE = '/pw-change';
export const REPOSITORY = '/repository';
export const FAQS = '/faqs';
export const RESOURCES = '/resources';



// WEBPACK FOOTER //
// ./src/constants/routes.js